/**
 * Конфигурация хранилища Redux
 * 
 * Отвечает за:
 * - Настройку хранилища Redux
 * - Комбинирование редьюсеров
 * - Экспорт типов для типизации в React-компонентах
 */
import { configureStore, Action, combineReducers } from '@reduxjs/toolkit';
import { ThunkAction } from 'redux-thunk';
import languageReducer from './slices/languageSlice';
import trainingsReducer from './slices/trainingsSlice';
import bonusVideosReducer from './slices/bonusVideosSlice';
import freeVideoReducer from './slices/freeVideoSlice';
import instructionReducer from './slices/instructionSlice';
import presentationReducer from './slices/presentationSlice';
import beforeAfterReducer from './slices/beforeAfterSlice';
import statisticsReducer from './slices/statisticsSlice';
import notificationsReducer from './slices/notificationsSlice';
import { RESET_STORE } from './actions/resetStore';

/**
 * Комбинированный редьюсер со всеми слайсами
 */
const appReducer = combineReducers({
    language: languageReducer, // Редьюсер для управления языком
    trainings: trainingsReducer,
    bonusVideos: bonusVideosReducer, // Редьюсер для управления бонусными видео
    freeVideo: freeVideoReducer, // Редьюсер для управления бесплатным видео
    instruction: instructionReducer, // Редьюсер для управления видео-инструкциями
    presentation: presentationReducer, // Редьюсер для управления презентационным видео
    beforeAfter: beforeAfterReducer, // Редьюсер для управления фото До/После
    statistics: statisticsReducer, // Редьюсер для управления статистикой пользователей
    notifications: notificationsReducer, // Редьюсер для управления уведомлениями
});

/**
 * Root редьюсер с поддержкой сброса состояния
 */
const rootReducer = (state: any, action: any) => {
    // При logout сбрасываем весь store в начальное состояние
    if (action.type === RESET_STORE) {
        state = undefined;
    }
    return appReducer(state, action);
};

/**
* Конфигурация хранилища с подключенными редьюсерами
*/
export const store = configureStore({
    reducer: rootReducer,
});

/**
 * Тип корневого состояния Redux для использования в TypeScript
 */
export type RootState = ReturnType<typeof store.getState>;

/**
 * Тип диспетчера Redux для типизации dispatch-функций
 */
export type AppDispatch = typeof store.dispatch;

/**
 * Тип для типизации thunk-функций
 */
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>; 